import React, { useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { Accordion } from 'react-bootstrap';
import Info from '../components/Info/Info';
import { Icon } from 'lb-components';
import {
  Back,
  CashDeskLogos,
  Map,
  Video,
} from 'lb-components/src/stories/assets/icons/payment';

import classes from '../components/Info/Info.module.scss';
import { UseNavigation } from 'lb-store/src/hooks';
import UseBottomBar from 'lb-store/src/hooks/useBottomBar';
const withdrawFee = 6;
const entries = [
  {
    key: 'Lb',
    video: '',
    map: { url: '/branches?mainOnly=1' },
    limit: {
      min: '1',
      max: '10 000',
      maxAmount: '200 000',
      fee: withdrawFee,
    },
  },
  {
    key: 'LeaderPay',
    video: '',
    map: { url: '/branches' },
    limit: { min: '1', max: '30 000', fee: withdrawFee,maxAmount: '200 000', },
  },
  {
    key: 'Tbc',
    video: '',
    map: {
      url: 'https://www.tbcbank.ge/web/ka/web/guest/branches-and-atms',
      external: true,
    },
    limit: { min: '1', max: '3 000', fee: withdrawFee,maxAmount: '50 000', },
  },
];

export default ({ platform, actionType, t, ...props }) => {
  const nav = UseNavigation();
  const { Close } = UseBottomBar();

  const header = useCallback(
    (item) => (
      <>
        <span
          onClick={(e) => {
            e.stopPropagation();
            if (item.map.external) window.open(item.map.url);
            else {
              nav.navigate(item.map.url);
              Close();
            }
          }}
          style={{
            textDecoration: 'underline',
            display: 'flex',
            marginRight: '1.8rem',
          }}
        >
          <Icon
            height={'2.5rem'}
            width={'1.9rem'}
            Icon={Map}
            style={{ marginRight: '1rem' }}
          />
          {t('სალაროები')}
        </span>
      </>
    ),
    []
  );
  return (
    <Accordion>
      {entries.map((item) => (
        <Info
          platform={platform}
          t={t}
          limit={item.limit}
          key={item.key}
          eventKey={item.key}
          actionType={actionType}
          {...(platform === 'web' && { header: header(item) })}
          content={
            <>
              {platform === 'mob' && (
                <div
                  className={classes.details}
                  style={{
                    justifyContent: 'space-around',
                    width: 'calc(100% + 2.5rem)',
                    marginLeft: '-1.25rem',
                    marginBottom: '1.5rem',
                    backgroundColor: '#F5F5F5',
                    padding: '1rem',
                    borderRadius: '4px',
                  }}
                >
                  {header(item)}
                </div>
              )}
            </>
          }
          logo={CashDeskLogos[item.key]}
          style={{ margin: '1rem 0' }}
        />
      ))}
    </Accordion>
  );
};
